<div class="update-invalid-email-modal text-align-center">
  <h3 class="t-9@r red-color text-transform-uppercase font-weight-500 mb-4@r">Is your email correct?</h3>
  <h2 class="t-4@r font-weight-500 mb-4@r word-break-break-all">
    {{ email }}
  </h2>
  <p class="ash-color t-8@r mb-4@r">
    An up-to-date email is important for account security. The last email we sent didn't reach you.
  </p>
  <button
    class="mb-2@r width-100"
    sbButton
    [queryParams]="{ redirect_source: 'invalid_email_modal' }"
    [routerLink]="['/next/settings/email']"
    [size]="'big'"
    [stretchable]="true"
    [variant]="'fill-green'"
    (click)="confirm()"
  >
    Update Email
  </button>
  <button
    class="ash-color width-100"
    sbButton
    [size]="'small'"
    [stretchable]="true"
    [variant]="'fill-light'"
    (click)="close()"
  >
    Not now
  </button>
</div>
